// Remembers the company the user last explicitly selected, so it can be made active
// again on the next sign-in instead of falling back to the backend's default pick.
// The stored value is only ever applied when it matches a company in the current
// user's own list, and the switch itself is still authorized server-side.
const LAST_COM_KEY = "cpass_last_com"

export const getLastCompany = (): string => {
    try {
        return localStorage.getItem(LAST_COM_KEY) || ""
    } catch (e) {
        console.error('localStorage error:', e);
        return ""
    }
}

export const setLastCompany = (com: string) => {
    if (!com) return
    try {
        localStorage.setItem(LAST_COM_KEY, com)
    } catch (e) {
        console.error('localStorage error:', e);
    }
}

export const clearLastCompany = () => {
    try {
        localStorage.removeItem(LAST_COM_KEY)
    } catch (e) {
        console.error('localStorage error:', e);
    }
}
